import React, { useState } from 'react'
import { GetServerSideProps } from 'next'
import { useRouter } from 'next/router'
import Icon from 'components/elements/Icon'

import { imageDirectory } from 'environment'

import { SectionResponse } from 'services/apiTypes/comment.types'

import { CommentService } from 'services/comment.service'

import PageWrapper from 'components/misc/PageWrapper'
import CardBanner from 'components/misc/CardBanner'
import InlineAd from 'components/advertisments/InlineAd'
import PhatInput from 'components/formElements/PhatInput'
import ListOfThreads from 'components/forumPage/ListOfThreads'
import LinkButton from 'components/elements/LinkButton'
import PhatButton from 'components/formElements/PhatButton'

import { LOG_ERROR_AND_REDIRECT } from 'utils/ErrorString'

import styles from './forumList.module.scss'

type Props = {
  category: string
  section: string
  threads: SectionResponse
}

const ForumListPage = ({ category, section, threads }: Props) => {
  const router = useRouter()

  const [search, setSearch] = useState(`${router.query.q || ''}`)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    router.push(`/forum/${category}/${section}?q=${search}&page=1`)
  }

  const BannerTitle = (
    <p>
      <Icon name="comments outline" />
      {section}
    </p>
  )

  return (
    <PageWrapper>
      <CardBanner
        src={`${imageDirectory}ths/46febc5d-1625-4e48-bb3f-31ee06fc13dd_art_crop.jpg`}
        height="250px"
        artist
        title={BannerTitle}
      />

      <div className={styles.content}>
        <InlineAd id="comments-top" banner longBanner renderVisibleOnly={false} />

        <div className={styles.controls}>
          <form onSubmit={handleSubmit} className={styles.search}>
            <PhatInput value={search} header="Search" placeholder="Search Forum" onChange={setSearch} />
            <PhatButton type="submit" icon="search">
              Search
            </PhatButton>
          </form>
          <div className={styles.links}>
            <a
              className={styles.discordButton}
              href="https://discord.gg/GyAAANU8uJ"
              rel="noopener noreferrer"
              target="_blank">
              <Icon name="discord" />
              Ask on Discord
            </a>
            <LinkButton href={`/forum/thread/new?section=${section}`}>New Thread</LinkButton>
          </div>
        </div>

        <ListOfThreads section={section} category={category} threads={threads} />
      </div>
    </PageWrapper>
  )
}

export default ForumListPage

export const getServerSideProps: GetServerSideProps<Props> = async context => {
  try {
    const [category, section] = context.params?.forumList || []

    const page = `${context.query.page || '1'}`
    const orderBy = `${context.query.orderBy || '-updatedAt'}`
    const q = `${context.query.q || ''}`

    const threads = await new CommentService(context).sections({ category, section, page, q, orderBy })

    return { props: { category, section, threads } }
  } catch (err) {
    return LOG_ERROR_AND_REDIRECT(err, context)
  }
}
